<template>
  <div style="padding: 1.25rem;"  >
    <div v-if="liad_show">
      <load></load>
    </div>
    <el-col :span="3">
      <el-row style="background-color: white;padding: 1.25rem;border-radius: 3px; ">
        <span class="left" @click="selest_add('radio')">单选题</span>
        <span class="left"  @click="selest_add('checkbox')">多选题</span>
        <span class="left"  @click="selest_add('input')">填空题</span>
      </el-row>
    </el-col>
    <el-col :span="20"  >
      <div   ref="con" class="right_con"  >
        <div style="background-color: white;padding: 1.25rem;border-radius: 3px;" ref="all">
          <el-input v-model="input"  type="textarea" autosize placeholder="问卷标题"></el-input>
        </div>
        <div v-if="show=='ture'" >
          <el-row v-if="list.length!=0">
            <el-row  >
              <el-row  v-for="(item,index) in list" :key="index" :class="show_index==index ? 'kapian2' : 'kapian1'" style="margin-top: 0.625rem;background-color: white;padding: 1.125rem 1.875rem 1.875rem 1.25rem;border-radius: 0.5625rem;">
                <el-col :span="1" >
                  <span style="height: 2.5rem;display: flex;align-items: center;font-size: 18px;">{{index+1}}</span>
                </el-col>
                <el-col :span="21" >
                  <div  @click="show_height(index)" >
                    <el-row style="display: flex;justify-content: center;align-items: center;">
                      <el-input type="textarea" autosize v-model="item.name" placeholder="请填写问题题目" @input="elinput()"></el-input>
                       <el-tooltip class="item" effect="light" content="刪除本道題" placement="top">
                          <i class="el-icon-delete" style="float: right;cursor: pointer;" @click="del(index,'-1')"></i>
                        </el-tooltip>
                    </el-row>
                    <el-row style="margin-left: 1.25rem;">
                      <el-row v-if="item.type!='input'" style="margin-top: 0.3125rem;display: flex;align-items: center;" v-for="(items,indexs) in item.choice" :key="indexs">
                        <span  :class="item.type=='radio'? 'el-radio__inner':'el-checkbox__inner'" style="margin-right: 0.3125rem;"></span>
                        <el-input type="textarea" autosize v-model="items.name" placeholder="选项" @input="elinput()"></el-input>
                        <el-tooltip class="item" effect="light" content="刪除本选项" placement="top">
                           <i class="el-icon-remove-outline" style="cursor: pointer;" @click="del(index,indexs)"></i>
                         </el-tooltip>
                      </el-row>
                      <el-row v-if="item.type=='input'"  style="border: 1px solid #d8d8d8; width: 25rem;height: 1.875rem;">
                      </el-row>
                      <el-row style="margin-top: 0.625rem;cursor: pointer;" v-if="item.type!='input'">
                        <span style="color: #2672ff;" @click="add_choice(item,index,)">+添加选项</span>
                      </el-row>
                    </el-row>
                  </div>

                </el-col>
              </el-row>
            </el-row>
            <el-row style="background-color: white;height: 6.25rem; display: flex; justify-content: center;align-items: center; margin-top: 3.125rem;">
              <el-button type="primary" @click="preservation()">保存</el-button>
            </el-row>
          </el-row>
        </div>
        <el-row v-if="list.length==0" class="nonum">
          <span>
            点击左侧 单选题、多选题、填空题就可以创建问卷了，
            快来操作吧！！！！！！
          </span>
        </el-row>
      </div>

    </el-col>
  </div>
</template>

<script>
  import load from "../../../../components/load.vue"
    export default {
      data() {
        return {
          liad_show:false,
          con_height:'',
          show:'false',
          list:[],
          input:'',
          show_index:'-1',
          up_type:'save',
        }
      },
      components: {
         load:load
      },
      mounted () {
         let topHeight = this.$refs.con.offsetHeight
         if(this.$route.query.num!=undefined){
           this.get_info()

         }

      },

      methods: {
        get_info(){
          let _this=this
          _this.show='falst'
          _this.liad_show=true
          _this.axios.get("/v2/c_investigate/investigate_info",{params: {
            num:_this.$route.query.num
          }}).then(function (res) {
            if(res.data.code=='1'){
              if(res.data.data.c_id=='0'){
                 _this.up_type='save'
              }else{
                _this.up_type='edit'
              }
              _this.input=res.data.data.name
              _this.list=res.data.data.content
              _this.liad_show=false
            }else{
              _this.$message.error(res.data.msg)
              _this.liad_show=false
            }
          })
         _this.show='ture'
        },
        show_height(index){
          let _this=this
          _this.show='falst'
          _this.show_index=index
          _this.show='ture'
        },
        elinput(){
          let _this=this
          _this.show='falst'
          _this.show='ture'
        },
        preservation(){
          if(this.input==''){
            this.$message.error('问卷调查名称不能为空');
            return
          }
          for(let i=0;i<this.list.length;i++){
            if(this.list[i].name==''){
               this.$message.error('您的第'+(i+1)+'题的题目名称未填写，题目名称必填哦');
               return
            }else{
              if(this.list[i].type!="input"){
                for(let j=0;j<this.list[i].choice.length;j++){
                  if(this.list[i].choice[j].name==''){
                    this.$message.error('您的第'+(i+1)+'题的选项为空，请注意');
                    return
                  }
                }
              }

            }
          }
          this.investigate_up()
        },
        investigate_up(){
          let _this=this
          let data={}
          if(_this.up_type=='save'){
            data={
              type:_this.up_type,
              name:_this.input,
              list:JSON.stringify(_this.list)
            }
          }else{
            data={
              type:_this.up_type,
              num:_this.$route.query.num,
              name:_this.input,
              list:JSON.stringify(_this.list)
            }
          }
          _this.liad_show=true
          _this.axios.post("/v2/c_investigate/investigate_up",{data:data}).then(function (res) {
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.liad_show=false
              _this.$router.push({path:'/quest_preview',query:{num:res.data.data.num}})
            }else{
              _this.$message.error(res.data.msg)
              _this.liad_show=false
            }
          })
        },
        del(index,indexs){
          let _this=this
          _this.show='falst'
          if(indexs=='-1'){
            _this.list.splice(index,1)
          }else{
            _this.list[index].choice.splice(indexs,1)
          }

          _this.show='ture'
        },
        add_choice(item,index){
          let _this=this
          let data={
            name:''
          }
          _this.show='falst'
          _this.list[index].choice[ _this.list[index].choice.length]=data
          _this.show='ture'
        },
        selest_add(type_select){
          let _this=this
          let data={}
          if(type_select=='input'){
            data={
              name:'',
              type:'input',
            }
          }else{
            if(type_select=='radio'){
              data={
                name:'',
                type:'radio',
                choice:[{
                    name:''
                  },
                  {
                    name:''
                  },
                ]
              }
            }else{
              data={
                name:'',
                type:'checkbox',
                choice:[{
                    name:''
                  },
                  {
                    name:''
                  },
                ]
              }
            }

          }
          _this.show='falst'
          _this.list[_this.list.length]=data
          _this.show='ture'
          _this.$nextTick(function() {
                  _this.$refs.con.scrollTop=_this.$refs.con.scrollHeight;
          })
          _this.show_index=_this.list.length-1
        }
      }

    }
</script>

<style  scoped>
  .kapian1{
  }
  .kapian2{
    border: 2px solid #2672ff;
  }
  .right_con{
    margin-left: 1.25rem; padding-bottom: 1.25rem; height: calc(100vh - 50px); overflow: auto;
  }
  .right_con::-webkit-scrollbar {
    display: none;
  }
  .nonum{
    margin-top: 1.875rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px dashed #aaa;
      border-radius: 4px;
      width: 100%;
      height: 300px;
      font-size: 14px;
      color: #484848;
  }
  .left{
    position: relative;
        display: inline-block;
        padding: 0.3125rem 1.25rem;
        line-height: 28px;
        /* color: #707070; */
        font-size: 12px;
        border: 1px solid #eaeaea;
        background-color: #fff;
        border-radius: 2px;
        margin: 0 0.375rem 0.375rem 0;
        cursor: pointer;
        box-sizing: border-box;
        vertical-align: middle;
        text-align: center;
  }
  >>>.el-input__inner {
    border-color:white;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/questionnaire/quest_list/add.vue